import React, { Suspense, useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Login from './plateform/components/Login/index';
import BuddyBooks from './plateform/containers/student/BuddyBooks';
import BookList from './plateform/components/BookList';
import PrivateRoute from './routes/PrivateRoute';
import ReviewPage from './plateform/containers/student/ReviewPage';
import GlobalMedia from './utils/globalMedia';
import PreparingBookPage from './plateform/components/PreparingBookPage';
import ReviewPageNew from './plateform/containers/student/ReviewPageNew';
import axios from 'axios';
import NoInternetScreen from './utils/NoInternetScreen';

// const BuddyBooks = React.lazy(() => import('./plateform/containers/student/BuddyBooks'));

GlobalMedia();

function App() {

  let errorCount = 0;

  const [noNetwork,setNoNetwork] = useState(false)

  useEffect(() => {
    let intervalId;

    window.addEventListener('online', handleNetworkEvent);
    window.addEventListener('offline', handleNetworkEvent);
  
    // if (noNetwork) {
    //   intervalId = setInterval(() => {
    //     axios('http://internal-dev-web.objectiveed.com/')
    //       .then((res) => {
    //         if (res && res.status === 200) {
    //           window.location.reload();
    //         }
    //       })
    //       .catch((error) => {
    //         console.error(error.message);
    //       });
    //   }, 5000);
    // }
  
    return () => {
      window.removeEventListener('online', handleNetworkEvent);
      window.removeEventListener('offline', handleNetworkEvent);
      clearInterval(intervalId);
    };
  }, [noNetwork]);

  const handleNetworkEvent = (event) => {
    if(event.type === 'online'){
      if(window.navigator.onLine && noNetwork){
        window.location.reload()}
    }
    if(event.type === 'offline'){
      if(!window.navigator.onLine || !noNetwork)setNoNetwork(true)
    }
  }

// axios interceptor to detect network failure
  axios.interceptors.response.use((response) => {
    return response
  },
  (error)=>{
    if (!error.response && error.message === "Network Error" && !noNetwork){
      errorCount++;
      if(errorCount > 5) {
        setNoNetwork(true)
        errorCount=0;
      }
    }
    return Promise.reject(error);
  })


  return (
    <BrowserRouter>
      <div className="App">
        {/* <Suspense fallback={<div>Loading...</div>}> */}
        {noNetwork ? <Route path="/" component={NoInternetScreen} /> :
        <Switch>
            <Route path="/" component={Login} exact />
            <PrivateRoute path='/book-page' component={PreparingBookPage} exact />
            <PrivateRoute exact path="/story/:storyId"
              render={({ match, history }) => <BuddyBooks history={history} id={match.params.storyId} />} />
            <PrivateRoute path="/booklist" component={BookList} exact />
            {/* <PrivateRoute path="/review_page" component={ReviewPage} exact /> */}
            <PrivateRoute path="/review_page" component={ReviewPageNew} exact />
            <Route component={Login} />
          </Switch>
        }
        {/* </Suspense> */}
      </div>
    </BrowserRouter>
  );
}

export default App;
